/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description helper function to persist messaged listings/building
 */

import { localStorageSingleton } from '@zcode/nr-utils'
import { APPLY, TOUR } from '../../../constants/message'

const saveMessagedToLocalStorage = ({
  equalCTAIntent,
  messagedBuildingIds,
  messagedListingIds,
  timestamp,
}) => {
  const localMessaged = localStorageSingleton.get('messaged') ?? {}
  const equalTourMessaged = localStorageSingleton.get('equalTourMessaged') ?? {}
  const equalApplyMessaged = localStorageSingleton.get('equalApplyMessaged') ?? {}
  const equalCheckAvailabilityMessaged =
    localStorageSingleton.get('equalCheckAvailabilityMessaged') ?? {}
  if (!localMessaged.buildings) {
    localMessaged.buildings = {}
  }
  if (!localMessaged.listings) {
    localMessaged.listings = {}
  }
  if (Array.isArray(messagedBuildingIds)) {
    messagedBuildingIds.forEach((buildingId) => {
      localMessaged.buildings[buildingId] = timestamp
    })
  }
  if (Array.isArray(messagedListingIds)) {
    messagedListingIds.forEach((listingId) => {
      localMessaged.listings[listingId] = timestamp
    })
  }
  localStorageSingleton.set('messaged', localMessaged)

  if (equalCTAIntent === TOUR) {
    if (!equalTourMessaged.buildings) {
      equalTourMessaged.buildings = {}
    }
    if (!equalTourMessaged.listings) {
      equalTourMessaged.listings = {}
    }
    if (Array.isArray(messagedBuildingIds)) {
      messagedBuildingIds.forEach((buildingId) => {
        equalTourMessaged.buildings[buildingId] = timestamp
      })
    }
    if (Array.isArray(messagedListingIds)) {
      messagedListingIds.forEach((listingId) => {
        equalTourMessaged.listings[listingId] = timestamp
      })
    }
    localStorageSingleton.set('equalTourMessaged', equalTourMessaged)
  }
  if (equalCTAIntent === APPLY) {
    if (!equalApplyMessaged.buildings) {
      equalApplyMessaged.buildings = {}
    }
    if (!equalApplyMessaged.listings) {
      equalApplyMessaged.listings = {}
    }
    if (Array.isArray(messagedBuildingIds)) {
      messagedBuildingIds.forEach((buildingId) => {
        equalApplyMessaged.buildings[buildingId] = timestamp
      })
    }
    if (Array.isArray(messagedListingIds)) {
      messagedListingIds.forEach((listingId) => {
        equalApplyMessaged.listings[listingId] = timestamp
      })
    }
    localStorageSingleton.set('equalApplyMessaged', equalApplyMessaged)
  }
  if (equalCTAIntent !== APPLY && equalCTAIntent !== TOUR) {
    if (!equalCheckAvailabilityMessaged.buildings) {
      equalCheckAvailabilityMessaged.buildings = {}
    }
    if (!equalCheckAvailabilityMessaged.listings) {
      equalCheckAvailabilityMessaged.listings = {}
    }
    if (Array.isArray(messagedBuildingIds)) {
      messagedBuildingIds.forEach((buildingId) => {
        equalCheckAvailabilityMessaged.buildings[buildingId] = timestamp
      })
    }
    if (Array.isArray(messagedListingIds)) {
      messagedListingIds.forEach((listingId) => {
        equalCheckAvailabilityMessaged.listings[listingId] = timestamp
      })
    }
    localStorageSingleton.set('equalCheckAvailabilityMessaged', equalCheckAvailabilityMessaged)
  }
}

export default saveMessagedToLocalStorage
